
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import ContactHero from './components/ContactHero';
import ContactForm from './components/ContactForm';
import ContactDetails from './components/ContactDetails';
import StockistHighlight from './components/StockistHighlight';

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-white overflow-x-hidden">
      <Navbar />
      <ContactHero />
      
      <section className="py-12 md:py-24 px-4 md:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-8 md:gap-12">
            {/* Info shown first on mobile, form below */}
            <div className="w-full lg:w-1/2 order-1 lg:order-2">
              <ContactDetails />
            </div>
            <div className="w-full lg:w-1/2 order-2 lg:order-1">
              <ContactForm />
            </div>
          </div>
        </div>
      </section>

      <StockistHighlight />
      <Footer />
    </div>
  );
}
